// src/components/EmailAuthForm.js
import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase";
import { buttons, fontSizes, rounded, spacing } from "../styles/tokens";

export default function EmailAuthForm({ onSuccess }) {
  const [mode, setMode] = useState("login"); // login | register
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pendingVerification, setPendingVerification] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      if (!userCredential.user.emailVerified) {
        await signOut(auth);
        setPendingVerification(true);
      } else {
        onSuccess?.();
      }
    } catch (err) {
      alert("Login failed: " + err.message);
    }
  };

  const handleRegister = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await sendEmailVerification(userCredential.user);
      setPendingVerification(true);
    } catch (err) {
      alert("Registration failed: " + err.message);
    }
  };

  const handleResend = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      setEmailSent(true);
    } catch (err) {
      alert("Failed to resend verification: " + err.message);
    }
  };

  if (pendingVerification) {
    return (
      <div className={`p-4 max-w-sm mx-auto ${spacing.gapMd} space-y-4`}>
        <h2 className="text-xl font-semibold text-center">Verify Your Email</h2>
        <p className={fontSizes.base}>
          We sent a verification email to <strong>{email}</strong>. Please check your inbox and verify your email before logging in.
        </p>
        <button
          onClick={handleResend}
          className={`${buttons.whitePurple} ${rounded.md}`}
        >
          Resend Email
        </button>
        {emailSent && <p className="text-green-600 text-sm text-center">Email resent ✅</p>}
      </div>
    );
  }

  return (
    <div className={`p-4 max-w-sm mx-auto ${spacing.gapMd} space-y-4`}>
      <h2 className="text-xl font-semibold text-center">
        {mode === "login" ? "Login with Email" : "Register with Email"}
      </h2>
      <input
        type="email"
        placeholder="Email"
        value={email}
        className="w-full p-2 border rounded"
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        className="w-full p-2 border rounded"
        onChange={(e) => setPassword(e.target.value)}
      />
      <button
        onClick={mode === "login" ? handleLogin : handleRegister}
        className={`${buttons.whitePurple} ${rounded.md} w-full`}
      >
        {mode === "login" ? "Login" : "Register"}
      </button>
      <button
        onClick={() => setMode(mode === "login" ? "register" : "login")}
        className="text-sm text-gray-500 hover:underline w-full text-center"
      >
        {mode === "login"
          ? "Don't have an account? Register"
          : "Already have an account? Login"}
      </button>
    </div>
  );
}
